import TextField from "@mui/material/TextField";
import { useState } from "react";

function DiscountInput(props) {
  const [value, setValue] = useState(
    props.defaultValue !== null && props.defaultValue !== undefined
      ? String(props.defaultValue)
      : "",
  );

  const handleChange = (e) => {
    let inputValue = e.target.value;

    // اجازه خالی کردن
    if (inputValue === "") {
      setValue("");
      props.action("");
      return;
    }

    // فقط عدد
    if (!/^\d+$/.test(inputValue)) {
      return;
    }

    let numberValue = Number(inputValue);

    // حداکثر 100
    if (numberValue > 100) {
      numberValue = 100;
      inputValue = "100";
    }

    // حداقل 0
    if (numberValue < 0) {
      numberValue = 0;
      inputValue = "0";
    }

    setValue(inputValue);

    props.action(numberValue);
  };

  return (
    <TextField
      label={props.title || "تخفیف سایت(درصد)"}
      className={props.class}
      value={value}
      onChange={handleChange}
      type="text"
      fullWidth={props.fullWidth}
      disabled={props.disabled}
      dir={props.direction}
      inputProps={{
        inputMode: "numeric",
        pattern: "[0-9]*",
      }}
    />
  );
}

export default DiscountInput;
